var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.iframeLogedIn)?[_c('iframe',{ref:"iframe1",style:(_vm.frameStyle),attrs:{"src":_vm.url,"width":"100%","title":"Admin"}})]:[_c('div',{staticClass:"loader",staticStyle:{"margin-top":"250px"}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }